<template>
    <v-btn-toggle v-model="divisione" divided color="primary" 
        variant="outlined" group class="mb-6 d-flex flex-grow-1"
        v-if="!isFormReadOnly" mandatory tile>
        <v-btn :value="'B'" class="flex-grow-1">
            Briofita
        </v-btn>
        <v-btn :value="false" selected class="flex-grow-1">
            <v-icon class="">mdi-filter-off</v-icon>
        </v-btn>
        <v-btn :value="'V'" class="flex-grow-1">
            Vascolare
        </v-btn>
    </v-btn-toggle>
</template>

<script setup>

import { ref, computed, onMounted, inject } from "vue";

const divisione = defineModel()

// const props = defineProps(["label","resolution", "clearable"])
const isFormReadOnly = ref(false) 



onMounted(() => {


    const svf = inject(Symbol.for("vuetify:form"), { isReadonly: false })
    isFormReadOnly.value = svf.isReadonly.value

    if (!divisione?.value) {
        divisione.value = false
    }
})
</script>
